import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import GlobalContext from '../../contexts/global.js';
import Listing from '../../components/Listing.js';
import { changeBrowserTitle } from '../../hooks/headAmender.js';
import locationBadgeIcon from '../../helpers/locationBadgeIcon.js';
import PageNotFound from './PageNotFound.js';

const PropertyListing = () => {
    const { globalContext } = useContext(GlobalContext);
    const { propertyId, value } = useParams();

    const properties = globalContext?.extraPageFields?.properties;
    const property = properties?.find(candidate => candidate.id === propertyId);

    if(properties && !property) {
        return <PageNotFound />;
    }

    const valueLabel = property?.items?.find(item => item.key === value)?.value ?? value;
    const heading = [
        ...new Set([property?.name || propertyId, valueLabel])
    ].join(": ");

    changeBrowserTitle(`${heading}${globalContext?.siteConfig?.siteName ? ` - ${globalContext.siteConfig.siteName}` : ""}`);

    return (
        <section>
            <Listing
                heading={heading}
                filterGroups={[{ key: propertyId, value }]}
                badgeKeys={[{ key: "location", icon: locationBadgeIcon }]}
                initialCount={9}
                paginateBy={9}
            />
        </section>
    );
};

export default PropertyListing;
